import LabServiceModel from "@/models/LabServiceModel";
import ProjectCollection from "@/collections/lab/ProjectCollection";
import InstrumentInstanceCollection from "@/collections/lab/InstrumentInstanceCollection";

export default class LaboratoryModel extends LabServiceModel {
  icon() {
    return "building";
  }
  modelName() {
    return 'laboratory';
  }
  defaults() {
    return {
      id: null,
      name: null,
      legal_name: null,
      code: null,
      phone: null,
      fax: null,
      email: null,
      website: null,
      address: null,
      address2: null,
      country: null,
      city: null,
      region: null,
      postal: null,
      gst_number: null,
      description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      instrument_instances: [],
      projects: []
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      legal_name: (val) => (this.nullStringMutator(val)),
      code: (val) => (this.nullStringMutator(val)),
      phone: (val) => (this.nullStringMutator(val)),
      fax: (val) => (this.nullStringMutator(val)),
      email: (val) => (this.nullStringMutator(val)),
      website: (val) => (this.nullStringMutator(val)),
      address: (val) => (this.nullStringMutator(val)),
      address2: (val) => (this.nullStringMutator(val)),
      country: (val) => (this.nullStringMutator(val)),
      city: (val) => (this.nullStringMutator(val)),
      region: (val) => (this.nullStringMutator(val)),
      postal: (val) => (this.nullStringMutator(val)),
      gst_number: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getProjects() {
    return this.getRelatedCollection(new ProjectCollection(), 'projects');
  }
  getInstrumentInstances() {
    return this.getRelatedCollection(new InstrumentInstanceCollection(), 'instrument_instances');
  }

}
